import config from "./config";

export const LUXURY_FALLBACK_IMAGE =
  'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="600" height="450" viewBox="0 0 600 450"><rect width="100%" height="100%" fill="%23FBF8F2"/><rect x="20" y="20" width="560" height="410" rx="16" fill="none" stroke="%23D4AF37" stroke-width="2" stroke-dasharray="6 6" stroke-opacity="0.5"/><text x="50%" y="46%" dominant-baseline="middle" text-anchor="middle" font-family="Georgia, serif" font-size="20" font-weight="bold" fill="%23B8962E">Sua Personal Shopper</text><text x="50%" y="56%" dominant-baseline="middle" text-anchor="middle" font-family="sans-serif" font-size="13" fill="%238C7335">Curadoria de Luxo</text></svg>';

/**
 * Converte qualquer URL de imagem (seja relativa /auctions/image-proxy, S3 ou absoluta)
 * em uma URL válida acessível pelo navegador.
 */
export const formatAuctionImageUrl = (url) => {
  if (!url || typeof url !== "string") {
    return LUXURY_FALLBACK_IMAGE;
  }

  const trimmed = url.trim();
  if (!trimmed) return LUXURY_FALLBACK_IMAGE;

  // Se já é uma URL completa ou data URI
  if (trimmed.startsWith("http://") || trimmed.startsWith("https://") || trimmed.startsWith("data:")) {
    return trimmed;
  }

  // Se for caminho relativo (ex: /auctions/image-proxy?... ou /auctions/studio-thumb/...)
  const apiBase = String(config.API_URL || "http://localhost:8000").replace(/\/$/, "");
  const normalizedPath = trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
  return `${apiBase}${normalizedPath}`;
};

export const getAuctionThumbUrl = (url) => {
  const formatted = formatAuctionImageUrl(url);
  if (!formatted || formatted.startsWith("data:")) return formatted;
  if (formatted.includes("image-proxy")) return formatted;
  const dot = formatted.lastIndexOf(".");
  if (dot === -1) return formatted;
  return formatted.slice(0, dot) + "_thumb.jpg";
};
